import { Button, Card } from '@/common'

export default function MissingResourcesAlert({
  title,
  description,
  action,
  actionChildren
}: {
  title: string
  description?: string
  action?: {
    label: string
    onClick: () => void
    disabled?: boolean
  }
  actionChildren?: React.ReactNode
}) {
  return (
    <Card className="w-full flex flex-col items-center justify-center p-4 gap-4">
      <div className="flex flex-col items-center justify-center">
        <p className="font-medium text-gray-600">{title}</p>
        {description && <p className="text-gray-500">{description}</p>}
      </div>
      {action && <Button onClick={action.onClick}>{action.label}</Button>}
      {actionChildren && actionChildren}
    </Card>
  )
}
